import React, { useRef, useState, useEffect } from 'react';
import tocIcon from './Icons/toc.svg';
import toccloseIcon from './Icons/arrow_circle_left.svg';
import playIcon from './Icons/L-Action.svg';
import pauseIcon from './Icons/Pause.svg';
import unmuteIcon from './Icons/volume_up.svg';
import ccIcon  from './Icons/closed_caption.svg';
import speed  from './Icons/slow_motion_video.svg';
import fullscreenIcon  from './Icons/fullscreen.svg';


const VideoPlayer1 = ({ videoSrc2, captions, toggleMute, isMuted, audioDescriptions, handleFullscreen, onVideoEnd, incrementCount, decreaseCount, completed, Toclink1,Toclink2,Toclink3 }) => {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const audioRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showCaptions, setShowCaptions] = useState(false);
  const [nextactive, setNextActive] = useState(false);
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [isToc, setIsToc] = useState(false);
  const [audioDescriptionsEnabled, setAudioDescriptionsEnabled] = useState(false); // State to enable/disable audio descriptions

  const [showSpeedDropdown, setShowSpeedDropdown] = useState(false);
  const [currentSpeed, setCurrentSpeed] = useState(1);

  
  // const playIcon = '/assets/images/L-Action.png';
  // const pauseIcon = '/assets/images/Pause.png';
  // const ccIcon = '/assets/images/closed_caption.png';
  // const fullscreenIcon = '/assets/images/fullscreen.png';
  const muteIcon = '/assets/images/mute.png';
  const audio_description = '/assets/images/audio_description.png';
  // const unmuteIcon = '/assets/images/volume_up.png';
  // const speed = '/assets/images/slow_motion_video.png';
  const nextIcon = '/assets/images/chevron_right.png';
  const backIcon = '/assets/images/chevron_left.png';
  // const tocIcon = '/assets/images/toc.png';
  //const toccloseIcon = '/assets/images/arrow_circle_right.png';



  const handleVolumeChange = (e) => {
    videoRef.current.volume = e.target.value;
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);

  const handleProgressChange = (e) => {
    const newTime = (e.target.value / 100) * duration;
    videoRef.current.currentTime = newTime;
    setCurrentTime(newTime);
    if (videoRef.current.currentTime >= duration) {
      // Handle video completion (e.g., trigger some function or update state)
      onVideoEnd();  // Assuming you want to call this function when the video ends
    }
  };

  const updateProgress = () => {
    if (!isDragging) {
      const currentVideoTime = videoRef.current.currentTime;
      setCurrentTime(currentVideoTime);
  
      // Check if the video has reached 100%
   
    }
  };

  const setVideoDuration = () => {
    setDuration(videoRef.current.duration);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener('timeupdate', updateProgress);
      video.addEventListener('loadedmetadata', setVideoDuration);
      video.addEventListener('ended', handleVideoEnd); // Add event listener for video end
      setIsPlaying(true)
      video.play();
    }
    return () => {
      if (video) {
        video.removeEventListener('timeupdate', updateProgress);
        video.removeEventListener('loadedmetadata', setVideoDuration);
        video.removeEventListener('ended', handleVideoEnd); // Clean up the event listener
      }
    };
  }, []); 

  const togglePlayPause = () => {
    const video = videoRef.current;

    if (video.paused) {
        video.play().then(() => {
            setIsPlaying(true); // Video is now playing, so set isPlaying to true
        }).catch(error => {
            console.error("Error while playing the video:", error);
        });
    } else {
        video.pause();
        setIsPlaying(false); // Video is now paused, so set isPlaying to false
    }
};

const handleVideoEnd = () => {
  setIsPlaying(false);
  
  // Check if `audioRef` and `videoRef` exist before accessing
 
  
  setTimeout(() => {
    setNextActive(true);
  }, 2000);

  if (onVideoEnd) {
    onVideoEnd(); // Call the provided onVideoEnd function (if necessary)
  }
};

  const handleMouseDown = () => {
    setIsDragging(true);
    videoRef.current.pause();
    setIsPlaying(false)
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    
    // Check if the video is at or near the end
    if (videoRef.current.currentTime >= videoRef.current.duration - 0.5) {
      // Prevent the video from playing automatically if it's at the end
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };


  const toggleCaptions = () => {
    setShowCaptions((prev) => !prev);
  };

  const handlePlaybackSpeedChange = (speed) => {
    videoRef.current.playbackRate = speed;
    setCurrentSpeed(speed);
    setPlaybackSpeed(speed);
    setShowSpeedDropdown(false);
  };
  const checkAudioDescriptions = () => {
    if (audioDescriptions) {
      audioDescriptions.forEach((description) => {
        if (
          currentTime >= description.startTime &&
          currentTime <= description.endTime &&
          !audioRef.current.paused
        ) {
          videoRef.current.pause();
        } else if (
          currentTime > description.endTime &&
          audioRef.current.paused &&
          isPlaying
        ) {
          videoRef.current.play();
        }
      });
    }
  };
  const handleAudioDescription = (audioSrc) => {
    audioRef.current.src = audioSrc;
    audioRef.current.play().then(() => {
      setIsPlaying(false); // Pause the video when audio description plays
    }).catch(error => {
      console.error("Error playing audio description:", error);
    });
  };
  const toggleSpeedDropdown = () => {
    setShowSpeedDropdown((prev) => !prev);
  };
  const handleAudioDescriptionsToggle = () => {
    setAudioDescriptionsEnabled((prev) => !prev); // Toggle audio descriptions
  };






  return (
    <>
    <div className="overlay-header"><h3 id="video-summary">Summary</h3></div>
    
    <video ref={videoRef} playsinline="" src={videoSrc2}  aria-hidden="true" preload="metadata" className="video-player" tabindex="-1" disablepictureinpicture=""></video>

  
    <div className="over" id="over" style={{}}>
      <h1 style={{ fontSize: '3vw' }}>Click on the Back button to revisit content.</h1>
    </div>
  
    <button
      className='toc-open-btn'
      style={{ position: 'absolute', padding: '0' }}
      onClick={() => setIsToc(true)}
      title='TOC Menu'
      aria-label="Open Table of Contents"
    >
<img src={tocIcon} alt="Table of Contents Icon" style={{
  width: 'clamp(20px, 2vw + 1vh, 30px)',
  height: 'clamp(20px, 2vw + 1vh, 30px)',
  background: '#d50019',
  padding: 'clamp(2px, 0.3vw + 0.2vh, 10px)',
}} />    </button>
    
    <button
      className='toc-close-btn'
      title='Close TOC Menu'
      style={{ position: 'absolute', display: isToc ? 'block' : 'none', padding: '0' }}
      onClick={() => setIsToc(false)}
      aria-label="Close Table of Contents"
    >
      <img src={toccloseIcon} alt="Close Table of Contents Icon" style={{   width: 'clamp(20px, 2vw + 1vh, 30px)',
  height: 'clamp(20px, 2vw + 1vh, 30px)', background: '#d50019', padding: '0.3vw' }} />
    </button>
  
    <div className={isToc ? 'toc' : 'toc-closed'} aria-label="Table of contents">
      <p style={{ padding: '0.5vw', background: '#d50019', color: 'white', display: 'flex', fontSize: '1vw' }}>
        <strong>Outline</strong>
        <img src={tocIcon} style={{ marginLeft: 'auto', display: 'flex', width: '2vw', height: '2vw' }} alt="Outline icon" />
      </p>
      <p style={{ padding: '0 0.5vw', color: 'black' }}>
        <a 
          href='#' 
          onClick={completed.includes(1) ? Toclink1 : null} 
          className='custom-link'
          style={{ color: completed.includes(1) ? '' : 'grey', background:'none', textDecoration: 'none', borderRadius: '0.5vw', padding: '0.2vw 1vw', width: '100%', display: 'block', fontSize: '1vw' }} 
          aria-label="Introduction to the Clamp Meter"
        >
          Introduction to the Clamp Meter
        </a>
        <a 
          href='#' 
          onClick={completed.includes(2) ? Toclink2 : null} 
          className='custom-link'
          style={{ color: completed.includes(2) ? '' : 'grey', background:'none', textDecoration: 'none', borderRadius: '0.5vw', padding: '0.2vw 1vw', width: '100%', display: 'block', fontSize: '1vw' }}
          aria-label="Using a Clamp Meter"
        >
          Using a Clamp Meter
        </a>
        <a 
          href='#' 
          onClick={completed.includes(3) ? Toclink3 : null} 
          className='custom-link' style={{textDecoration: 'none'}} 
          aria-label="Summary"
        >
          Summary
        </a>
      </p>
    </div>
  
    
    <button 
  style={{
    position: 'absolute', 
    left: '1vw', 
    zIndex: '1000', 
    fontSize: 'clamp(6px, 1vw + 1vh, 12px)',
    display: !isToc ? '' : 'none',
     /* Responsive font size */
  }} 
  className='back' 
  onClick={decreaseCount}
  aria-label="Go back"
>
  <img 
    src={backIcon} 
    alt="Back" 
    style={{
      width: 'clamp(15px, 2vw + 1vh, 20px)', /* Responsive image size */
    }} 
  /> 
  Back
</button>
  
    {/* <button 
      style={{ position: 'absolute', right: '1vw', zIndex: '1000', background: 'grey', cursor: 'not-allowed' }} 
      disabled
      title='Next' 
      className='next' 
      aria-label="Next"
    >
      Next
      <img src={nextIcon} alt="Next" style={{ width: '2vw', background: 'grey' }} />
    </button> */}
  
    <div className="controls" aria-label="Video controls">
      <button 
        onClick={togglePlayPause} 
        title={isPlaying ? 'Pause Video' : 'Play Video'} 
        className="control-button" 
        aria-label={isPlaying ? 'Pause the video' : 'Play the video'}
      >
        <img className='btn-img' src={isPlaying ? pauseIcon : playIcon} alt={isPlaying ? 'Pause' : 'Play'} />
      </button>
  
      <span className="time-display">
        {formatTime(currentTime)}/{formatTime(duration)}
       </span>
  
      <input
        type="range"
        min="0"
        max="100"
        style={{ width: '75%', height: '0.3vw',marginLeft:'1%' }}
        value={(currentTime / duration) * 100 || 0}
        onInput={handleProgressChange}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        aria-label="Video progress"
      />
  
  <button onClick={toggleMute} className="control-button" title={isMuted ? 'Unmute' : 'Mute'}>
        <img className='btn-img' src={isMuted ? muteIcon : unmuteIcon} alt={isMuted ? 'Mute' : 'Unmute'} />
      </button>
      
      <button onClick={handleAudioDescriptionsToggle} title='Audio Descriptions' className="control-button">
          <img className='btn-img' src={audio_description} alt="audio_description" />
  
        </button>
      <button onClick={toggleCaptions} title='Closed Captioning' className={`control-button ${showCaptions ? 'active' : ''}`}>
        <img className='btn-img' src={ccIcon} alt="Captions" />
      </button>
      
  
    
        <>
      <div className="speed-control">
      <button onClick={toggleSpeedDropdown}  title="Playback Speed"  className={`control-button ${showSpeedDropdown ? 'active' : ''}`}>
    <img src={speed} alt="Speed" className='btn-img' style={{height:'90%', width:'90%', verticalAlign:'middle'}}/>
  </button>
  
  {showSpeedDropdown && (
    <ul className="speed-dropdown">
      {[0.5, 1, 1.5, 2].map((speed) => (
        <li key={speed} onClick={() => handlePlaybackSpeedChange(speed)} style={{ display: 'flex', alignItems: 'center', cursor:'pointer' }}>
          <span style={{ marginRight: '8px', fontSize: '1.2em', color: speed === currentSpeed ? 'white' : 'transparent' }}>•</span>
          {speed}x
        </li>
      ))}
    </ul>
  )}
</div>

</>
      <button onClick={handleFullscreen} title='Full Screen' className="control-button">
        <img className='btn-img' src={fullscreenIcon} alt="Fullscreen" />
      </button>
    </div>
  
    {showCaptions && (
      <div className="captions" aria-live="polite">
        {captions.map((caption, index) => (
          currentTime >= caption.startTime && currentTime <= caption.endTime && (
            <span key={index}>{caption.text}</span>
          )
        ))}
      </div>
    )}
  </>
  
  );
};

export default VideoPlayer1;
